const convertDate = (date, isStringToDate = false) => {
  if (isStringToDate) {
    const [dayIdx, monthIdx, yearIdx] = [0, 1, 2];

    const day = Number(date?.split('.')[dayIdx]);
    const month = Number(date?.split('.')[monthIdx]) - 1;
    const year = Number(date?.split('.')[yearIdx]);

    return new Date(year, month, day);
  } else {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    // Возвращает дату формата "31.01.2000",
    // учитывая зону местного времеми
    const result =
      `${day > 9 ? day : `0${day}`}.` +
      `${month > 9 ? month : `0${month}`}.` +
      `${year}`;

    return result ? String(result) : '';
  }
};

export default convertDate;
